import Api from "./api";

export default {
  async deleteSchool(config, school, userId) {
    const response = await Api(config).delete(
      `${config.schoolApi}/school-teacher/${school.id}/${userId}/${school.year}`
    );
    return response.data;
  },
  async deleteClusterTeacher(config, clusterId, userId) {
    const response = await Api(config).delete(`${config.schoolApi}/cluster-teacher/${clusterId}/${userId}`);
    return response.data;
  },
  async getClusters(config) {
    const response = await Api(config).get(`${config.schoolApi}/cluster?limit=1000`);
    return response.data;
  },
  async getClusterTeacher(config, userId) {
    const response = await Api(config).get(`${config.schoolApi}/cluster-teacher?user_id=${userId}`);
    return response.data;
  },
  async getSchools(config, params) {
    const response = await Api(config).get(`${config.schoolApi}/school`, { params });
    return response;
  },
  async getUpdateAgencies(config) {
    const response = await Api(config).get(`${config.agencyUpdate}`);
    return response.data;
  },
  async saveClusterTeacher(config, body) {
    const response = await Api(config).post(`${config.schoolApi}/cluster-teacher`, body);
    return response.data;
  },
  async saveSchool(config, body) {
    const response = await Api(config).post(`${config.schoolApi}/school-teacher`, body);
    return response.data;
  },
};
